import { ClientConfigurationEffects } from './client-configuration.effects';
export const effects: any[] = [ClientConfigurationEffects];
